import { api } from "./client";
import type { User } from "./types";

export async function loginOAuth(provider: "google" | "microsoft" = "google"): Promise<User> {
  // MVP: mock OAuth — backend zwraca user'a wybranego na ekranie loginu.
  // S7 BLOK C: ukryte w UI (`<SocialLoginButtons v-if="false">`), zostawione w kodzie.
  const r = await api.post<User>("/api/auth/oauth", { provider });
  return r.data;
}

/**
 * Login email/hasło (awaryjny, `POST /login`). Mock-server ignoruje hasło, backend waliduje
 * lokalnym bcryptem (tylko przy CRM_PASSWORD_LOGIN=1).
 */
export async function loginEmail(email: string, password: string): Promise<User> {
  const r = await api.post<User>("/login", { email, password });
  return r.data;
}

export async function logout(): Promise<void> {
  await api.post("/logout").catch(() => undefined);
}

export async function me(): Promise<User | null> {
  try {
    const r = await api.get<User>("/api/v1/me");
    return r.data;
  } catch {
    return null;
  }
}

export async function loginAsMock(userId: number): Promise<User> {
  // Tylko dla developmentu: szybki picker user'a bez OAuth.
  const r = await api.post<User>("/api/auth/mock-login", { user_id: userId });
  return r.data;
}
